import { render, staticRenderFns } from "./PlanModal.vue?vue&type=template&id=5882856d&"
import script from "./PlanModal.vue?vue&type=script&lang=js&"
export * from "./PlanModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports